/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-BPM-CONNECTOR API
 * API specification for MALIYONE-BPM-CONNECTOR
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssignUserRoleParams,
  ClaimTaskParams,
  CreateUserRoleParams,
  GetAllProcessInstancesParams,
  GetTasksByProcessInstanceParams,
  GetTasksForGroupAndStatusParams,
  GetTasksForGroupParams,
  GetTasksForUserParams,
  GetTasksParams,
  Message,
  ProcessInstance,
  ProcessInstanceEvent,
  ProcessTask,
  RemoveUserRoleParams,
  Task,
  TaskEvent,
  User,
  Version
} from './schemas/bpmServiceSchemas';

import { customAxiosInstanceMutator } from './custom-axios-instance';
/**
 * @summary API version
 */
export const getVersion = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Version>(
      {url: `/bpm/api/v1/version`, method: 'GET', signal
    },
      );
    }
  



export const getGetVersionQueryKey = () => {
    return [
    `/bpm/api/v1/version`
    ] as const;
    }

    
export const getGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({ signal }) => getVersion(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getVersion>>>
export type GetVersionQueryError = unknown


export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary API version
 */

export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a user with role
 */
export const createUserRole = (
    user: User,
    params: CreateUserRoleParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Message>(
      {url: `/bpm/api/v1/identity/create-user-role`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: user,
        params, signal
    },
      );
    }
  


export const getCreateUserRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserRole>>, TError,{data: User;params: CreateUserRoleParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUserRole>>, TError,{data: User;params: CreateUserRoleParams}, TContext> => {

const mutationKey = ['createUserRole'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserRole>>, {data: User;params: CreateUserRoleParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createUserRole(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof createUserRole>>>
    export type CreateUserRoleMutationBody = User
    export type CreateUserRoleMutationError = unknown

    /**
 * @summary Create a user with role
 */
export const useCreateUserRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserRole>>, TError,{data: User;params: CreateUserRoleParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserRole>>,
        TError,
        {data: User;params: CreateUserRoleParams},
        TContext
      > => {

      const mutationOptions = getCreateUserRoleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Assign a user to role
 */
export const assignUserRole = (
    params: AssignUserRoleParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Message>(
      {url: `/bpm/api/v1/identity/assign-user-role`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getAssignUserRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignUserRole>>, TError,{params: AssignUserRoleParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof assignUserRole>>, TError,{params: AssignUserRoleParams}, TContext> => {

const mutationKey = ['assignUserRole'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignUserRole>>, {params: AssignUserRoleParams}> = (props) => {
          const {params} = props ?? {};

          return  assignUserRole(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof assignUserRole>>>
    
    export type AssignUserRoleMutationError = unknown

    /**
 * @summary Assign a user to role
 */
export const useAssignUserRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignUserRole>>, TError,{params: AssignUserRoleParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignUserRole>>,
        TError,
        {params: AssignUserRoleParams},
        TContext
      > => {

      const mutationOptions = getAssignUserRoleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Remove a user from role
 */
export const removeUserRole = (
    params: RemoveUserRoleParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Message>(
      {url: `/bpm/api/v1/identity/remove-user-role`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getRemoveUserRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeUserRole>>, TError,{params: RemoveUserRoleParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeUserRole>>, TError,{params: RemoveUserRoleParams}, TContext> => {

const mutationKey = ['removeUserRole'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeUserRole>>, {params: RemoveUserRoleParams}> = (props) => {
          const {params} = props ?? {};

          return  removeUserRole(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof removeUserRole>>>
    
    export type RemoveUserRoleMutationError = unknown

    /**
 * @summary Remove a user from role
 */
export const useRemoveUserRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeUserRole>>, TError,{params: RemoveUserRoleParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeUserRole>>,
        TError,
        {params: RemoveUserRoleParams},
        TContext
      > => {

      const mutationOptions = getRemoveUserRoleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Start a new process instance
 */
export const startWorkflow = (
    workflowKey: string,
    processTask: ProcessTask,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ProcessInstance>(
      {url: `/bpm/api/v1/process/${workflowKey}/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: processTask, signal
    },
      );
    }
  


export const getStartWorkflowMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startWorkflow>>, TError,{workflowKey: string;data: ProcessTask}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof startWorkflow>>, TError,{workflowKey: string;data: ProcessTask}, TContext> => {

const mutationKey = ['startWorkflow'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startWorkflow>>, {workflowKey: string;data: ProcessTask}> = (props) => {
          const {workflowKey,data} = props ?? {};

          return  startWorkflow(workflowKey,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof startWorkflow>>>
    export type StartWorkflowMutationBody = ProcessTask
    export type StartWorkflowMutationError = unknown

    /**
 * @summary Start a new process instance
 */
export const useStartWorkflow = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startWorkflow>>, TError,{workflowKey: string;data: ProcessTask}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startWorkflow>>,
        TError,
        {workflowKey: string;data: ProcessTask},
        TContext
      > => {

      const mutationOptions = getStartWorkflowMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Retrieve tasks for a specific user
 */
export const getTasks = (
    params: GetTasksParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Task[]>(
      {url: `/bpm/api/v1/tasks`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetTasksQueryKey = (params?: GetTasksParams,) => {
    return [
    `/bpm/api/v1/tasks`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTasksQueryOptions = <TData = Awaited<ReturnType<typeof getTasks>>, TError = unknown>(params: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasks>>> = ({ signal }) => getTasks(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getTasks>>>
export type GetTasksQueryError = unknown


export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = unknown>(
 params: GetTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = unknown>(
 params: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = unknown>(
 params: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve tasks for a specific user
 */

export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = unknown>(
 params: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Retrieve tasks for a specific user
 */
export const getTasksByProcessInstance = (
    params: GetTasksByProcessInstanceParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Task[]>(
      {url: `/bpm/api/v1/tasks/process-instance`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetTasksByProcessInstanceQueryKey = (params?: GetTasksByProcessInstanceParams,) => {
    return [
    `/bpm/api/v1/tasks/process-instance`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTasksByProcessInstanceQueryOptions = <TData = Awaited<ReturnType<typeof getTasksByProcessInstance>>, TError = unknown>(params: GetTasksByProcessInstanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByProcessInstance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksByProcessInstanceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksByProcessInstance>>> = ({ signal }) => getTasksByProcessInstance(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasksByProcessInstance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksByProcessInstanceQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksByProcessInstance>>>
export type GetTasksByProcessInstanceQueryError = unknown


export function useGetTasksByProcessInstance<TData = Awaited<ReturnType<typeof getTasksByProcessInstance>>, TError = unknown>(
 params: GetTasksByProcessInstanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByProcessInstance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksByProcessInstance>>,
          TError,
          Awaited<ReturnType<typeof getTasksByProcessInstance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksByProcessInstance<TData = Awaited<ReturnType<typeof getTasksByProcessInstance>>, TError = unknown>(
 params: GetTasksByProcessInstanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByProcessInstance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksByProcessInstance>>,
          TError,
          Awaited<ReturnType<typeof getTasksByProcessInstance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksByProcessInstance<TData = Awaited<ReturnType<typeof getTasksByProcessInstance>>, TError = unknown>(
 params: GetTasksByProcessInstanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByProcessInstance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve tasks for a specific user
 */

export function useGetTasksByProcessInstance<TData = Awaited<ReturnType<typeof getTasksByProcessInstance>>, TError = unknown>(
 params: GetTasksByProcessInstanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByProcessInstance>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksByProcessInstanceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Retrieve tasks for a specific user
 */
export const getTasksForUser = (
    params: GetTasksForUserParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Task[]>(
      {url: `/bpm/api/v1/tasks/user`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetTasksForUserQueryKey = (params?: GetTasksForUserParams,) => {
    return [
    `/bpm/api/v1/tasks/user`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTasksForUserQueryOptions = <TData = Awaited<ReturnType<typeof getTasksForUser>>, TError = unknown>(params: GetTasksForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksForUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksForUser>>> = ({ signal }) => getTasksForUser(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasksForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksForUserQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksForUser>>>
export type GetTasksForUserQueryError = unknown


export function useGetTasksForUser<TData = Awaited<ReturnType<typeof getTasksForUser>>, TError = unknown>(
 params: GetTasksForUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksForUser>>,
          TError,
          Awaited<ReturnType<typeof getTasksForUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksForUser<TData = Awaited<ReturnType<typeof getTasksForUser>>, TError = unknown>(
 params: GetTasksForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksForUser>>,
          TError,
          Awaited<ReturnType<typeof getTasksForUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksForUser<TData = Awaited<ReturnType<typeof getTasksForUser>>, TError = unknown>(
 params: GetTasksForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve tasks for a specific user
 */

export function useGetTasksForUser<TData = Awaited<ReturnType<typeof getTasksForUser>>, TError = unknown>(
 params: GetTasksForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForUser>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksForUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Retrieve tasks for a specific group
 */
export const getTasksForGroup = (
    params: GetTasksForGroupParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Task[]>(
      {url: `/bpm/api/v1/tasks/group`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetTasksForGroupQueryKey = (params?: GetTasksForGroupParams,) => {
    return [
    `/bpm/api/v1/tasks/group`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTasksForGroupQueryOptions = <TData = Awaited<ReturnType<typeof getTasksForGroup>>, TError = unknown>(params: GetTasksForGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroup>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksForGroupQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksForGroup>>> = ({ signal }) => getTasksForGroup(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksForGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksForGroup>>>
export type GetTasksForGroupQueryError = unknown


export function useGetTasksForGroup<TData = Awaited<ReturnType<typeof getTasksForGroup>>, TError = unknown>(
 params: GetTasksForGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksForGroup>>,
          TError,
          Awaited<ReturnType<typeof getTasksForGroup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksForGroup<TData = Awaited<ReturnType<typeof getTasksForGroup>>, TError = unknown>(
 params: GetTasksForGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksForGroup>>,
          TError,
          Awaited<ReturnType<typeof getTasksForGroup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksForGroup<TData = Awaited<ReturnType<typeof getTasksForGroup>>, TError = unknown>(
 params: GetTasksForGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroup>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve tasks for a specific group
 */

export function useGetTasksForGroup<TData = Awaited<ReturnType<typeof getTasksForGroup>>, TError = unknown>(
 params: GetTasksForGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroup>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksForGroupQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Retrieve claimed tasks
 */
export const getClaimedTasks = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Task[]>(
      {url: `/bpm/api/v1/tasks/claimed`, method: 'GET', signal
    },
      );
    }
  



export const getGetClaimedTasksQueryKey = () => {
    return [
    `/bpm/api/v1/tasks/claimed`
    ] as const;
    }

    
export const getGetClaimedTasksQueryOptions = <TData = Awaited<ReturnType<typeof getClaimedTasks>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaimedTasks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClaimedTasksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClaimedTasks>>> = ({ signal }) => getClaimedTasks(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClaimedTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClaimedTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getClaimedTasks>>>
export type GetClaimedTasksQueryError = unknown


export function useGetClaimedTasks<TData = Awaited<ReturnType<typeof getClaimedTasks>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaimedTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClaimedTasks>>,
          TError,
          Awaited<ReturnType<typeof getClaimedTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClaimedTasks<TData = Awaited<ReturnType<typeof getClaimedTasks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaimedTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClaimedTasks>>,
          TError,
          Awaited<ReturnType<typeof getClaimedTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClaimedTasks<TData = Awaited<ReturnType<typeof getClaimedTasks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaimedTasks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve claimed tasks
 */

export function useGetClaimedTasks<TData = Awaited<ReturnType<typeof getClaimedTasks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaimedTasks>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClaimedTasksQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Retrieve unclaimed tasks
 */
export const getUnclaimedTasks = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Task[]>(
      {url: `/bpm/api/v1/tasks/unclaimed`, method: 'GET', signal
    },
      );
    }
  



export const getGetUnclaimedTasksQueryKey = () => {
    return [
    `/bpm/api/v1/tasks/unclaimed`
    ] as const;
    }

    
export const getGetUnclaimedTasksQueryOptions = <TData = Awaited<ReturnType<typeof getUnclaimedTasks>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedTasks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnclaimedTasksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnclaimedTasks>>> = ({ signal }) => getUnclaimedTasks(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUnclaimedTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getUnclaimedTasks>>>
export type GetUnclaimedTasksQueryError = unknown


export function useGetUnclaimedTasks<TData = Awaited<ReturnType<typeof getUnclaimedTasks>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnclaimedTasks>>,
          TError,
          Awaited<ReturnType<typeof getUnclaimedTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnclaimedTasks<TData = Awaited<ReturnType<typeof getUnclaimedTasks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnclaimedTasks>>,
          TError,
          Awaited<ReturnType<typeof getUnclaimedTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnclaimedTasks<TData = Awaited<ReturnType<typeof getUnclaimedTasks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedTasks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve unclaimed tasks
 */

export function useGetUnclaimedTasks<TData = Awaited<ReturnType<typeof getUnclaimedTasks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedTasks>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUnclaimedTasksQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Retrieve tasks for a specific group and status
 */
export const getTasksForGroupAndStatus = (
    params: GetTasksForGroupAndStatusParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Task[]>(
      {url: `/bpm/api/v1/tasks/group-status`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetTasksForGroupAndStatusQueryKey = (params?: GetTasksForGroupAndStatusParams,) => {
    return [
    `/bpm/api/v1/tasks/group-status`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTasksForGroupAndStatusQueryOptions = <TData = Awaited<ReturnType<typeof getTasksForGroupAndStatus>>, TError = unknown>(params: GetTasksForGroupAndStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroupAndStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksForGroupAndStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksForGroupAndStatus>>> = ({ signal }) => getTasksForGroupAndStatus(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroupAndStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksForGroupAndStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksForGroupAndStatus>>>
export type GetTasksForGroupAndStatusQueryError = unknown


export function useGetTasksForGroupAndStatus<TData = Awaited<ReturnType<typeof getTasksForGroupAndStatus>>, TError = unknown>(
 params: GetTasksForGroupAndStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroupAndStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksForGroupAndStatus>>,
          TError,
          Awaited<ReturnType<typeof getTasksForGroupAndStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksForGroupAndStatus<TData = Awaited<ReturnType<typeof getTasksForGroupAndStatus>>, TError = unknown>(
 params: GetTasksForGroupAndStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroupAndStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksForGroupAndStatus>>,
          TError,
          Awaited<ReturnType<typeof getTasksForGroupAndStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksForGroupAndStatus<TData = Awaited<ReturnType<typeof getTasksForGroupAndStatus>>, TError = unknown>(
 params: GetTasksForGroupAndStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroupAndStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve tasks for a specific group and status
 */

export function useGetTasksForGroupAndStatus<TData = Awaited<ReturnType<typeof getTasksForGroupAndStatus>>, TError = unknown>(
 params: GetTasksForGroupAndStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksForGroupAndStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksForGroupAndStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Complete a task
 */
export const completeTask = (
    taskId: string,
    processTask: ProcessTask,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Message>(
      {url: `/bpm/api/v1/tasks/${taskId}/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: processTask, signal
    },
      );
    }
  


export const getCompleteTaskMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{taskId: string;data: ProcessTask}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{taskId: string;data: ProcessTask}, TContext> => {

const mutationKey = ['completeTask'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeTask>>, {taskId: string;data: ProcessTask}> = (props) => {
          const {taskId,data} = props ?? {};

          return  completeTask(taskId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof completeTask>>>
    export type CompleteTaskMutationBody = ProcessTask
    export type CompleteTaskMutationError = unknown

    /**
 * @summary Complete a task
 */
export const useCompleteTask = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{taskId: string;data: ProcessTask}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeTask>>,
        TError,
        {taskId: string;data: ProcessTask},
        TContext
      > => {

      const mutationOptions = getCompleteTaskMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Claim a task
 */
export const claimTask = (
    taskId: string,
    params: ClaimTaskParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Message>(
      {url: `/bpm/api/v1/tasks/${taskId}/claim`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getClaimTaskMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimTask>>, TError,{taskId: string;params: ClaimTaskParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof claimTask>>, TError,{taskId: string;params: ClaimTaskParams}, TContext> => {

const mutationKey = ['claimTask'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimTask>>, {taskId: string;params: ClaimTaskParams}> = (props) => {
          const {taskId,params} = props ?? {};

          return  claimTask(taskId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClaimTaskMutationResult = NonNullable<Awaited<ReturnType<typeof claimTask>>>
    
    export type ClaimTaskMutationError = unknown

    /**
 * @summary Claim a task
 */
export const useClaimTask = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimTask>>, TError,{taskId: string;params: ClaimTaskParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof claimTask>>,
        TError,
        {taskId: string;params: ClaimTaskParams},
        TContext
      > => {

      const mutationOptions = getClaimTaskMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Un Claim a task
 */
export const unclaimTask = (
    taskId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Message>(
      {url: `/bpm/api/v1/tasks/${taskId}/unclaim`, method: 'POST', signal
    },
      );
    }
  


export const getUnclaimTaskMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unclaimTask>>, TError,{taskId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unclaimTask>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['unclaimTask'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unclaimTask>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  unclaimTask(taskId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnclaimTaskMutationResult = NonNullable<Awaited<ReturnType<typeof unclaimTask>>>
    
    export type UnclaimTaskMutationError = unknown

    /**
 * @summary Un Claim a task
 */
export const useUnclaimTask = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unclaimTask>>, TError,{taskId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unclaimTask>>,
        TError,
        {taskId: string},
        TContext
      > => {

      const mutationOptions = getUnclaimTaskMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get process instance details by ID
 */
export const getProcessInstanceById = (
    processInstanceId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ProcessInstance>(
      {url: `/bpm/api/v1/process-instances/${processInstanceId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetProcessInstanceByIdQueryKey = (processInstanceId?: string,) => {
    return [
    `/bpm/api/v1/process-instances/${processInstanceId}`
    ] as const;
    }

    
export const getGetProcessInstanceByIdQueryOptions = <TData = Awaited<ReturnType<typeof getProcessInstanceById>>, TError = unknown>(processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessInstanceByIdQueryKey(processInstanceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessInstanceById>>> = ({ signal }) => getProcessInstanceById(processInstanceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(processInstanceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessInstanceByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessInstanceById>>>
export type GetProcessInstanceByIdQueryError = unknown


export function useGetProcessInstanceById<TData = Awaited<ReturnType<typeof getProcessInstanceById>>, TError = unknown>(
 processInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceById>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceById<TData = Awaited<ReturnType<typeof getProcessInstanceById>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceById>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceById<TData = Awaited<ReturnType<typeof getProcessInstanceById>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get process instance details by ID
 */

export function useGetProcessInstanceById<TData = Awaited<ReturnType<typeof getProcessInstanceById>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessInstanceByIdQueryOptions(processInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Retrieve all process instances
 */
export const getAllProcessInstances = (
    params?: GetAllProcessInstancesParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ProcessInstance[]>(
      {url: `/bpm/api/v1/process-instances`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAllProcessInstancesQueryKey = (params?: GetAllProcessInstancesParams,) => {
    return [
    `/bpm/api/v1/process-instances`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllProcessInstancesQueryOptions = <TData = Awaited<ReturnType<typeof getAllProcessInstances>>, TError = unknown>(params?: GetAllProcessInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProcessInstances>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllProcessInstancesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllProcessInstances>>> = ({ signal }) => getAllProcessInstances(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllProcessInstances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllProcessInstancesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllProcessInstances>>>
export type GetAllProcessInstancesQueryError = unknown


export function useGetAllProcessInstances<TData = Awaited<ReturnType<typeof getAllProcessInstances>>, TError = unknown>(
 params: undefined |  GetAllProcessInstancesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProcessInstances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProcessInstances>>,
          TError,
          Awaited<ReturnType<typeof getAllProcessInstances>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllProcessInstances<TData = Awaited<ReturnType<typeof getAllProcessInstances>>, TError = unknown>(
 params?: GetAllProcessInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProcessInstances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProcessInstances>>,
          TError,
          Awaited<ReturnType<typeof getAllProcessInstances>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllProcessInstances<TData = Awaited<ReturnType<typeof getAllProcessInstances>>, TError = unknown>(
 params?: GetAllProcessInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProcessInstances>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve all process instances
 */

export function useGetAllProcessInstances<TData = Awaited<ReturnType<typeof getAllProcessInstances>>, TError = unknown>(
 params?: GetAllProcessInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProcessInstances>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllProcessInstancesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Webhook for task creation
 */
export const taskCreated = (
    taskEvent: TaskEvent,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/bpm/api/v1/webhook/task-created`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: taskEvent, signal
    },
      );
    }
  


export const getTaskCreatedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskCreated>>, TError,{data: TaskEvent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof taskCreated>>, TError,{data: TaskEvent}, TContext> => {

const mutationKey = ['taskCreated'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taskCreated>>, {data: TaskEvent}> = (props) => {
          const {data} = props ?? {};

          return  taskCreated(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TaskCreatedMutationResult = NonNullable<Awaited<ReturnType<typeof taskCreated>>>
    export type TaskCreatedMutationBody = TaskEvent
    export type TaskCreatedMutationError = unknown

    /**
 * @summary Webhook for task creation
 */
export const useTaskCreated = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskCreated>>, TError,{data: TaskEvent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taskCreated>>,
        TError,
        {data: TaskEvent},
        TContext
      > => {

      const mutationOptions = getTaskCreatedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Webhook for task assignment
 */
export const taskAssigned = (
    taskEvent: TaskEvent,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/bpm/api/v1/webhook/task-assigned`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: taskEvent, signal
    },
      );
    }
  


export const getTaskAssignedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskAssigned>>, TError,{data: TaskEvent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof taskAssigned>>, TError,{data: TaskEvent}, TContext> => {

const mutationKey = ['taskAssigned'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taskAssigned>>, {data: TaskEvent}> = (props) => {
          const {data} = props ?? {};

          return  taskAssigned(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TaskAssignedMutationResult = NonNullable<Awaited<ReturnType<typeof taskAssigned>>>
    export type TaskAssignedMutationBody = TaskEvent
    export type TaskAssignedMutationError = unknown

    /**
 * @summary Webhook for task assignment
 */
export const useTaskAssigned = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskAssigned>>, TError,{data: TaskEvent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taskAssigned>>,
        TError,
        {data: TaskEvent},
        TContext
      > => {

      const mutationOptions = getTaskAssignedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Webhook for task completion
 */
export const taskCompleted = (
    taskEvent: TaskEvent,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/bpm/api/v1/webhook/task-completed`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: taskEvent, signal
    },
      );
    }
  


export const getTaskCompletedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskCompleted>>, TError,{data: TaskEvent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof taskCompleted>>, TError,{data: TaskEvent}, TContext> => {

const mutationKey = ['taskCompleted'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taskCompleted>>, {data: TaskEvent}> = (props) => {
          const {data} = props ?? {};

          return  taskCompleted(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TaskCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof taskCompleted>>>
    export type TaskCompletedMutationBody = TaskEvent
    export type TaskCompletedMutationError = unknown

    /**
 * @summary Webhook for task completion
 */
export const useTaskCompleted = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskCompleted>>, TError,{data: TaskEvent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taskCompleted>>,
        TError,
        {data: TaskEvent},
        TContext
      > => {

      const mutationOptions = getTaskCompletedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Webhook for process instance start
 */
export const processStarted = (
    processInstanceEvent: ProcessInstanceEvent,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/bpm/api/v1/webhook/process-started`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: processInstanceEvent, signal
    },
      );
    }
  


export const getProcessStartedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processStarted>>, TError,{data: ProcessInstanceEvent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof processStarted>>, TError,{data: ProcessInstanceEvent}, TContext> => {

const mutationKey = ['processStarted'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processStarted>>, {data: ProcessInstanceEvent}> = (props) => {
          const {data} = props ?? {};

          return  processStarted(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProcessStartedMutationResult = NonNullable<Awaited<ReturnType<typeof processStarted>>>
    export type ProcessStartedMutationBody = ProcessInstanceEvent
    export type ProcessStartedMutationError = unknown

    /**
 * @summary Webhook for process instance start
 */
export const useProcessStarted = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processStarted>>, TError,{data: ProcessInstanceEvent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof processStarted>>,
        TError,
        {data: ProcessInstanceEvent},
        TContext
      > => {

      const mutationOptions = getProcessStartedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Webhook for process instance completion
 */
export const processCompleted = (
    processInstanceEvent: ProcessInstanceEvent,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/bpm/api/v1/webhook/process-completed`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: processInstanceEvent, signal
    },
      );
    }
  


export const getProcessCompletedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processCompleted>>, TError,{data: ProcessInstanceEvent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof processCompleted>>, TError,{data: ProcessInstanceEvent}, TContext> => {

const mutationKey = ['processCompleted'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processCompleted>>, {data: ProcessInstanceEvent}> = (props) => {
          const {data} = props ?? {};

          return  processCompleted(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProcessCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof processCompleted>>>
    export type ProcessCompletedMutationBody = ProcessInstanceEvent
    export type ProcessCompletedMutationError = unknown

    /**
 * @summary Webhook for process instance completion
 */
export const useProcessCompleted = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processCompleted>>, TError,{data: ProcessInstanceEvent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof processCompleted>>,
        TError,
        {data: ProcessInstanceEvent},
        TContext
      > => {

      const mutationOptions = getProcessCompletedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
